<template>
  <div>
  <L1 class="SalesRecord">
    <template slot="slot_title">
      <span>
      <vue-ctk-date-time-picker :range="true" v-model="range" id="dts"
      :color="'var(--color-pri)'"
      :no-label="true"
      :input-size="'sm'"
      :label="'選取時間範圍'"
      :format="'YYYY-MM-DD'"
      :formatted="'YYYY-MM-DD'"
      @input="setDate()"/>
      </span>
      <!-- <button class="addBtn" @click="addProduct=true">新增不分潤商品</button> -->
    </template>
    <div class="boxContent">
    <div class="tableConsume">
    <table>
      <thead>
        <tr>
          <th v-for="t in th" :key="`th-${t}`">{{t}}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(rec, i) in records">
        <tr :key="`rec-${i}`">
          <td v-for="t in th" :key="`td-${i}-${t}`" :style="{whiteSpace:'nowrap', height:'50px'}">
            <span v-if="t==='營業日期'" v-html="moment(rec._id).format('YYYY-MM-DD (dd)')"></span>
            <span v-else-if="t==='單數'">{{rec.count}} ({{rec.type_1}}/{{rec.type_2}}/{{rec.type_4}})</span>
            <span v-else-if="t==='應稅金額'">{{formatDollar(rec.total)}}</span>
            <span v-else-if="t==='發票金額'">{{formatDollar(rec.totalnv)}}</span>
            <span v-else-if="t==='折扣'">{{formatDollar(rec.totalDiscountManual)}}</span>
            <span v-else-if="t==='稅額'">{{formatDollar(rec.totalInvoiceTax)}}</span>
            <span v-else-if="t==='銷售'">{{formatDollar(rec.total_1)}}</span>
            <span v-else-if="t==='取消'">{{formatDollar(rec.total_2)}}</span>
            <span v-else-if="t==='預購'">{{formatDollar(rec.total_4)}}</span>
            <span v-else>{{rec[t]}}</span>
          </td>
        </tr>
        </template>
      </tbody>
    </table>
    </div>
    <div class="chart1">
    <charts1 :range="range" :result="records"/>
    <charts2 :range="range" :result="products"/>
    </div>
    </div>
  </L1>
  <!-- <div class="test" :class="totalInfo?'opened':'closed'" @click="totalInfo=!totalInfo">
    <div><span>發票總計</span><span>{{formatDollar(total)}}</span></div>
    <div><span>應稅</span><span>{{formatDollar(subtotal)}}</span></div>
    <div><span>稅</span><span>{{formatDollar(taxtotal)}}</span></div>
    <div><span>總單數</span><span>{{records.length}}</span></div>
  </div> -->
  </div>
</template>

<script>
import L1 from '../../components/layout/L1.vue'
import { getapi } from '../../store/fetch'
import charts1 from './chart1'
import charts2 from './chart2'

export default {
  name: 'SalesRecord',
  components: {
    charts1,
    charts2,
    L1
  },
  data () {
    return {
      range: {
        start: this.moment().add(-7, 'day').startOf('day').format('YYYY-MM-DD'),
        end: this.moment().add(-1, 'day').endOf('day').format('YYYY-MM-DD')
      },
      totalInfo: false,
      searchText: null,
      rangeSelect: false,
      daterange: '單日',
      displayMode: '總計',
      records: [],
      products: [],
      total: 0,
      count: 0,
      th: [
        '營業日期',
        '單數',
        '應稅金額',
        '發票金額',
        '折扣',
        '稅額'
        // ,
        // '銷售',
        // '取消',
        // '預購'
      ]
    }
  },
  created () {
    this.getRecords()
  },
  watch: {
    searchText () { this.getRecords() },
    daterange () { if (this.range.start && this.range.end) { this.getRecords() } },
    range () { if (this.range.start && this.range.end) { this.getRecords() } },
    dt () { if (this.dt) { this.getRecords() } }
  },
  methods: {
    formatDollar (x) {
      const formatter = new Intl.NumberFormat('en-Us', { style: 'currency', currency: 'USD' })
      return formatter.format(parseInt(x))
    },
    async getRecords () {
      const dts = this.moment(this.range.start).startOf('day').toISOString()
      const dte = this.moment(this.range.end).endOf('day').toISOString()
      this.records = await getapi(`consumeRecords/week?dts=${dts}&dte=${dte}`)
      this.products = await getapi(`consumeRecords/products?dts=${dts}&dte=${dte}`)
    }
  }

}
</script>

<style lang="scss" scoped>
.boxContent {
  height: calc(100vh - 100px);
  // background-color: var(--color-infobox);
  display: flex;
  display: grid;
  grid-template-columns: 1fr 556px;
  padding: 20px;
  gap: 20px;
  .chart1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-sizing: border-box;
    width: calc(100% - 1000px);
  }
  table {
    width: 100%;
    border-collapse: collapse;
  }
  thead tr {
    background-color: var(--color-infobox);
    height: 40px;
  }
  th, td {
    padding-inline: 20px;
  }
}
.tableConsume {
  height: calc(100vh - 140px);
  border-radius: 10px;
  padding: 10px;
  border: 2px solid var(--color-border);
  // box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  table tbody {
    overflow-y: auto;
    max-height: 460px;
  }
}
.test.opened {
  position: absolute;
  top: 150px;
  right: 50px;
  font-size: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &>div{
    width: 360px;
    display: flex;
    justify-content: space-between;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  padding: 20px 50px;
  text-align: start;
  // box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
}
.test.closed {
  position: absolute;
  top: 15px;
  right: 50px;
  font-size: 26px;
  &>div:nth-child(1) {
    width: 360px;
    display: flex;
    justify-content: space-between;
  }
  &>div:not(:nth-child(1)) {
    display: none;
  }
  gap: 20px;
  color: var(--color-pri);
  background-color: var(--color-infobox);
  padding: 10px 20px;
  text-align: start;
  // box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
}
td, th {
  text-align: start;
  padding-inline: 5px;
  box-sizing: border-box;
  // &:nth-child(1) {padding-left: 50px;}
  &:nth-child(1) { width: 120px; padding-left: 23px;}
  &:nth-child(2) { width: 90px; text-align: start; }
  &:nth-child(3) { width: 130px; text-align: end; }
  &:nth-child(4) { width: 120px; text-align: end; }
  &:nth-child(5) { width: 140px; text-align: end; }
  &:nth-child(6) { width: 180px; text-align: end; padding-right: 43px; }
  &:nth-child(7) { width: 90px; text-align: end; }
  &:nth-child(8) { width: 90px; text-align: end;}
}
tr {
  &:not(.detail) span.型態 {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      background-color: var(--預約中);
      color: #FFFFFF;
    }
    &.預購 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
    &.訂金 {
      background-color: var(--已報到);
      color: #FFFFFF;
    }
    &.沖訂金 {
      background-color: var(--通知付訂);
      color: #FFFFFF;
    }
  }
  &.detail span.transCategory{
    display: inline-block;
    padding: 3px 10px;
    border-radius: 3px;
    &.銷售 {
      font-weight: bold;
      color: var(--預約中);
    }
    &.退貨 {
      font-weight: bold;
      color: var(--通知付訂);
    }
    &.訂金 {
      font-weight: bold;
      color: var(--已報到);
    }
    &.贈品 {
      font-weight: bold;
      color: var(--已取消);
    }
    &.沖訂金 {
      font-weight: bold;
      color: var(--通知付訂);
      color: #FFFFFF;
    }

  }
}
td:nth-child(8),
td:nth-child(9),
td:nth-child(10) {
  padding-inline: 15px;
}
th {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #000000;
}
td {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  color: var(--color-letter);
}
.search {
  width: 300px;
  height: 40px;
  box-sizing: border-box;
  background-image: url(/search.svg);
  background-position: calc(100% - 10px) 10px;
  background-repeat: no-repeat;
  border-radius: 3px;
  border: 1px solid #C4C4C4;
  text-indent: 12px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-top: 8px;
  &::placeholder {
    color: var(--color-border);
  }
}
.SalesRecord {
  height: 100vh;
  padding-inline: 18px 9px!important;
  .content {
    display: grid;
    grid-template-columns: 645px 1fr;
    grid-template-rows: calc(100vh - 89px);
    &>:nth-child(1) {
      border-right: 1px solid var(--color-border);
    }
    &>div {
      width: 100%;
      height: 100%;
      padding-block: 28px;
      padding-inline: 50px;
      box-sizing: border-box;
    }
  }
 }
.header {
  height: 89px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 20px;
  .headtitle {
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    letter-spacing: 0.15em;
  }
  span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }
}
.box {
  width: 422px;
  height: 505px;
  min-height: 505px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  box-sizing: border-box;
}
.SalesRecord input[type=radio] {
  min-width: 120px;
  width: 120px;
  height: 40px;
  background-color: var(--color-border);
  appearance: none;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
    font-family: Roboto;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
  &:checked {
    background-color: var(--color-checked);
  }
  &:hover {
    filter: contrast(.5);
  }
}
.SalesRecord input[type=date]{
  margin-top: 2px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  width: 215px;
  height: 36px;
  border: 1px solid var(--color-border);
  position: relative;
  padding-inline: 13px;
  box-sizing: border-box;
  &::-webkit-calendar-picker-indicator {
    background: none;
    width: 36px;
    height: 36px;
    mask-image: url(/calendar2.svg);
    position: absolute;
    color: var(--color-checked);
    top: 0;
    right: 0;
    mask-size: contain;
    background-color: var(--color-checked);
    mask-size: 22px;
    mask-repeat: no-repeat;
    mask-position: 8px 5px;
  }
}
</style>
<style lang="scss">
.SalesRecord {
  #dts-wrapper {
    width: 325px;
    height: 40px;
    .field::after {
      content: '';
      position: absolute;
      top: 2px;
      right: 2px;
      width: 36px;
      height: 36px;
      mask-size: contain;
      background-color: var(--color-checked);
      mask-size: 22px;
      mask-repeat: no-repeat;
      mask-position: 8px 6px;
      mask-image: url(/calendar2.svg);
    }
    .custom-button.round {
      margin-right: 30px;
    }
  }
  #dts-input {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 18px!important;
    line-height: 36px;
    height: 40px!important;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: 325px!important;
  }
}
</style>
